














































































































import {
  computed,
  defineComponent,
  ref,
  useContext,
  useRouter
} from '@nuxtjs/composition-api';
import VaimoBadge from 'atoms/VaimoBadge.vue';
import VaimoButton from 'atoms/VaimoButton.vue';
import VaimoProductVariant from 'atoms/VaimoProductVariant.vue';
import debounce from 'lodash.debounce';
import VaimoBooxiLifeTimeLabel from 'organisms/cart/parts/VaimoBooxiLifeTimeLabel.vue';
import VaimoCollectedProduct from 'organisms/cart/parts/VaimoCollectedProduct.vue';
import VaimoEngravingCard from 'organisms/cart/parts/VaimoEngravingCard.vue';
import VaimoQuantitySelector from 'organisms/VaimoQuantitySelector.vue';

import type { CartItemInterface } from '~/composables';
import { useConfig } from '~/composables';
import VaimoLoader from '~/diptyqueTheme/components/atoms/VaimoLoader.vue';
import { useBooxi } from '~/diptyqueTheme/composable/useBooxi';
import { useLink } from '~/diptyqueTheme/composable/useLink';
import {
  getBooxiLifetime,
  isVirtualCartItem
} from '~/diptyqueTheme/helpers/cart/booxi';
import { validateFraction } from '~/diptyqueTheme/helpers/priceFormatter';
import { Logger } from '~/helpers/logger';
import useCart from '~/modules/core/composables/useCart';
import cartGetters from '~/modules/core/getters/cartGetters';
import { useCartStore } from '~/modules/core/stores/cart';

export default defineComponent({
  name: 'VaimoCollectedProducts',
  components: {
    VaimoProductVariant,
    VaimoQuantitySelector,
    VaimoCollectedProduct,
    VaimoEngravingCard,
    VaimoBooxiLifeTimeLabel,
    VaimoBadge,
    VaimoLoader,
    VaimoButton
  },
  setup(_props, { root }) {
    const { config } = useConfig();
    const { i18n, localePath, app } = useContext();
    const router = useRouter();
    const { normalizeLink } = useLink();
    const { booxiLifeTimeData } = useBooxi();
    const cartStore = useCartStore();
    const initialLoading = computed(() => cartStore.initial_loading);

    const breadcrumbs = [
      {
        text: i18n.t('Home'),
        link: localePath({ name: 'home' })
      },
      {
        text: i18n.t('Basket'),
        link: localePath({ name: 'cart' })
      }
    ];
    const { cart, removeItem, updateItemQty, loading } = useCart();
    const products = computed(() =>
      cartGetters.getItems(cart.value).filter((product) => product)
    );

    const totalItems = computed(() =>
      cartGetters.getTotalItems(cartStore.cart)
    );
    const UPDATE_QUANTITY_DEBOUNCE = 500;
    const updateQuantity = debounce(async ({ product, quantity }) => {
      if (lastRemovedByMinus.value === product.id) return;
      if (quantity === 0) {
        await removeItem({ product });
      } else {
        await updateItemQty({ product, quantity });
      }

      root.$emit('reload-xmas-form');
    }, UPDATE_QUANTITY_DEBOUNCE);

    const lastRemovedByMinus = ref(null);
    const removeIfOne = ({ product, qty }, $event) => {
      if ($event.target.innerText === '-' && qty === 1) {
        lastRemovedByMinus.value = product.id;
        removeItem({ product });
      }
    };

    const { destroyBooxiReservation } = useBooxi();

    const removeItemFromCart = async (product) => {
      await removeItem({ product });
      if (isVirtualCartItem(product)) {
        destroyBooxiReservation();
      }
      app.$bus.$emit('remove-sample', product);
      const xmasSkus = config.value?.xmas_skus;
      if (
        Array.isArray(xmasSkus) &&
        xmasSkus.includes(cartGetters.getItemSku(product))
      ) {
        root.$emit('reload-xmas-form');
      }
    };

    const getProductPrice = (product) => {
      const cartProductPriceDisplayConfig =
        config.value?.tax_cart_display_price;
      return (
        (cartProductPriceDisplayConfig === '2'
          ? product.prices?.row_total_including_tax.value || 0
          : product.prices?.row_total.value) || 0
      );
    };

    const isOffertProduct = (price) => price === 0;

    const tryJsonParse = (str: string) => {
      try {
        return JSON.parse(str);
      } catch (error) {
        Logger.error('Error parsing JSON:', error);
        return null;
      }
    };

    const isSampleProduct = (product: CartItemInterface) => {
      if (!product.additional_data) return false;

      const parsedData = tryJsonParse(product.additional_data);
      return parsedData
        ? parsedData.is_sample || parsedData.is_checkout_sample || false
        : false;
    };

    const isXmasProduct = (product: CartItemInterface) => {
      if (!product.additional_data) return false;

      const parsedData = tryJsonParse(product.additional_data);
      return parsedData ? parsedData.is_xmas || false : false;
    };

    const isEngraving = (product) => {
      return !!product.engraving;
    };

    const getIsPreOrder = (product) => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      //@ts-ignore
      return product.product.preorder;
    };

    const getPreOrderLabel = (product) => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      //@ts-ignore
      return product.product.preorderStockNotice;
    };

    const getProductLink = (product) => {
      return normalizeLink(cartGetters.getSlug(product) as string);
    };

    const continueShopping = () => {
      router.push(normalizeLink('/'));
    };

    return {
      breadcrumbs,
      isOffertProduct,
      cart,
      removeItem,
      updateItemQty,
      loading,
      removeIfOne,
      products,
      totalItems,
      updateQuantity,
      cartGetters,
      initialLoading,
      removeItemFromCart,
      isXmasProduct,
      isSampleProduct,
      isEngraving,
      validateFraction,
      getProductLink,
      getProductPrice,
      continueShopping,
      getIsPreOrder,
      booxiLifeTimeData,
      getPreOrderLabel,
      isVirtualCartItem,
      getBooxiLifetime
    };
  }
});
